import { Switch } from 'react-router-dom'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import Shops from './Shops'
import Vehicles from './Vehicles'
import Orders from './Orders'
import Orderlines from './Orderlines'
import Accounts from './Accounts'
import Invoices from './Invoices'
import Appointments from './Appointments'
import Dashboard from './Dashboard/Dashboard'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_STATS } from 'app-support/permissions/Permissions'
import VehicleInvoices from './VehicleInvoices'
import {
  accountsStatsRoute,
  appointmentsStatsRoute,
  invoicesStatsRoute,
  orderLinesStatsRoute,
  ordersStatsRoute,
  shopsStatsRoute,
  statsRoute,
  vehicleInvoicesStatsRoute,
  vehiclesStatsRoute
} from 'routes/routeNames'

const enhance = withRegionSwitchHandler(statsRoute)

const StatsContainer = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_STATS} exact path={shopsStatsRoute} component={Shops} />
    <PermissionRoute permission={PERMISSION_MANAGE_STATS} exact path={vehiclesStatsRoute} component={Vehicles} />
    <PermissionRoute permission={PERMISSION_MANAGE_STATS} exact path={ordersStatsRoute} component={Orders} />
    <PermissionRoute permission={PERMISSION_MANAGE_STATS} exact path={orderLinesStatsRoute} component={Orderlines} />
    <PermissionRoute permission={PERMISSION_MANAGE_STATS} exact path={accountsStatsRoute} component={Accounts} />
    <PermissionRoute permission={PERMISSION_MANAGE_STATS} exact path={invoicesStatsRoute} component={Invoices} />
    <PermissionRoute permission={PERMISSION_MANAGE_STATS} exact path={vehicleInvoicesStatsRoute} component={VehicleInvoices} />
    <PermissionRoute permission={PERMISSION_MANAGE_STATS} exact path={appointmentsStatsRoute} component={Appointments} />
    <PermissionRoute permission={PERMISSION_MANAGE_STATS} exact path={statsRoute} component={Dashboard} />
  </Switch>
)

export default enhance(StatsContainer)
